export const TEMPLATE_TRANSLATION = {
  API_ERROR_FETCH_LANGUAGES_MESSAGE: {
    key: 'API_ERROR_FETCH_LANGUAGES_MESSAGE',
    value: 'An error occurred while attempting to fetch the languages',
  },
  API_ERROR_FETCH_TRANSLATED_TEMPLATES_MESSAGE: {
    key: 'API_ERROR_FETCH_TRANSLATED_TEMPLATES_MESSAGE',
    value: 'An error occurred while retrieving translated templates',
  },

  LANGUAGE_NOT_DETECTED_MESSAGE: {
    key: 'LANGUAGE_NOT_DETECTED_MESSAGE',
    value:
      'Language is not detected for this template, please write some text in order to detect the language.',
  },

  TEMPLATE_AVAILABLE_IN_LABEL: {
    key: 'TEMPLATE_AVAILABLE_IN_LABEL',
    value: 'Template available in',
  },
  LANGUAGES_AVAILABLE_LABEL: { key: 'LANGUAGES_AVAILABLE_LABEL', value: 'Available Languages' },

  DELETE_TOOLTIP: { key: 'DELETE_TOOLTIP', value: 'Delete' },
  TRANSLATE_BUTTON: { key: 'TRANSLATE_BUTTON', value: 'Translate' },
  CREATE_BUTTON: { key: 'CREATE_BUTTON', value: 'Create' },

  TEMPLATE_TRANSLATED_SUCCESS_MESSAGE: {
    key: 'TEMPLATE_TRANSLATED_SUCCESS_MESSAGE',
    value: 'Template translated successfully',
  },
  TEMPLATE_CREATED_SUCCESS_MESSAGE: {
    key: 'TEMPLATE_CREATED_SUCCESS_MESSAGE',
    value: 'Template created successfully'
  },
  TEMPLATE_TRANSLATE_ERROR_MESSAGE: {
    key: 'TEMPLATE_TRANSLATE_ERROR_MESSAGE',
    value: 'There was an error during the translation of the template',
  },
  TEMPLATE_CREATION_ERROR_MESSAGE: {
    key: 'TEMPLATE_CREATION_ERROR_MESSAGE',
    value: "We couldn't create the template. Please try again."
  },
  TEMPLATE_DELETED_SUCCESS_MESSAGE: {
    key: 'TEMPLATE_DELETED_SUCCESS_MESSAGE',
    value: 'Template deleted successfully',
  },
  TEMPLATE_DELETE_ERROR_MESSAGE: {
    key: 'TEMPLATE_DELETE_ERROR_MESSAGE',
    value: 'Failed to delete the template due to an error',
  },

  TEMPLATE_DELETE_CONFIRM_MESSAGE: {
    key: 'TEMPLATE_DELETE_CONFIRM_MESSAGE',
    value: 'Are you sure you want to delete this template?',
  },
  DELETE_BUTTON: { key: 'DELETE_BUTTON', value: 'Delete' },
  PREMIUM_PLAN_LIMIT_EXCEEDED_ERROR: { 
    key: 'PREMIUM_PLAN_LIMIT_EXCEEDED_ERROR', 
    value: "This translation exceeds your current plan's quota. You can either wait until your quota renews next month or upgrade to an enterprise plan. For assistance with upgrading, please contact our support team at <a href='mailto:{{emailId}}'>{{emailId}}</a>." 
  },
  STANDARD_PLAN_UPGRADE_MESSAGE: { 
    key: 'STANDARD_PLAN_UPGRADE_MESSAGE', 
    value: "In your standard plan, you've reached the translation limit of {{languageCharacter}} characters. Please upgrade your plan." 
  },
  FREE_PLAN_UPGRADE_MESSAGE: { 
    key: 'FREE_PLAN_UPGRADE_MESSAGE', 
    value: "Your current plan lacks the capability to translate text due to its limited features. To access this feature, please upgrade your plan." 
  },
  DOCUMENT_CREATION_LIMIT_EXCEEDED_ERROR: {
    key: 'DOCUMENT_CREATION_LIMIT_EXCEEDED_ERROR',
    value: 'Unable to translate this template because the template creation limit has been exceeded.'
  },
  LANGUAGE_UPDATED_SUCCESS_MESSAGE: {
    key: 'LANGUAGE_UPDATED_SUCCESS_MESSAGE',
    value: 'Language updated successfully'
  },
  UPDATE_LANGUAGE_ERROR_MESSAGE: {
    key: 'UPDATE_LANGUAGE_ERROR_MESSAGE',
    value: 'Failed to update the language'
  },
  LANGUAGES_UPDATE_SUCCESS_LABEL: { key: 'LANGUAGES_UPDATE_SUCCESS_LABEL', value: 'Language updated successfully' },
  ASSIGN_LANGUAGE_TOOLTIP: {
    key: 'ASSIGN_LANGUAGE_TOOLTIP',
    value: 'Assign language',
  },
  YET_TO_DETECT_LABEL: {
    key: 'YET_TO_DETECT_LABEL',
    value: 'Yet to detect',
  },
  TRANSLATION_LIMIT_EXCEEDED_WARNING: {
    key: 'TRANSLATION_LIMIT_EXCEEDED_WARNING',
    value: 'Your limit for translation has been exceeded.',
  }
};
